import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { useNavigate } from "react-router-dom";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const itemsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
  fetchUsers();
}, [search, filter, currentPage]);


  const fetchUsers = async () => {
  setLoading(true);
  setError("");
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(
      `${baseUrl}/users/list?search=${search}&status=${filter}&page=${currentPage}&perPage=${itemsPerPage}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    const result = await response.json();
    if (result.status === true && Array.isArray(result.data)) {
      setUsers(result.data);
      setTotalUsers(result.pagination?.total || 0);
    } else {
      throw new Error(result?.message || "Failed to fetch user list");
    }
  } catch (err) {
    setError(err.message);
  }
  setLoading(false);
};

  const filteredData = users.filter((item) => {
    const fullName = `${item.firstName} ${item.lastName}`;
    return (
      (filter === "All" || item.status === filter) &&
      (fullName.toLowerCase().includes(search.toLowerCase()) ||
        item.email.toLowerCase().includes(search.toLowerCase()) ||
        item.username.toLowerCase().includes(search.toLowerCase()))
    );
  });

  const totalPages = Math.ceil(totalUsers / itemsPerPage);

  // Pagination logic for 5-page window
  const maxVisiblePages = 5;
  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

  if (endPage - startPage < maxVisiblePages - 1) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  return (
    <div className="flex bg-gray-900 min-h-screen">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <Navbar />
        <div className="p-8">
          <h4 className="text-2xl font-semibold mb-4 text-white">Users</h4>
          {/* Search & Filter */}
          <div className="flex justify-between mb-6 bg-gray-800 p-4 rounded-lg shadow-md">
            <span className="text-sm text-gray-300 mt-2">
              Showing {filteredData.length} of {totalUsers} users
            </span>
            <input
            className="px-4 py-2 bg-gray-700 text-white rounded-lg w-1/3 focus:ring-2 focus:ring-blue-500"
              type="text"
              placeholder="Search..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1); // Reset page to 1 on search
              }}
            />

            {/* <select
              value={filter}
              onChange={(e) => {
                setFilter(e.target.value);
                setCurrentPage(1); // Reset page to 1 on filter
              }}
            >
              <option value="All">All</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select> */}
          </div>
          

          {/* Table */}
          {loading ? (
            <p>Loading users...</p>
          ) : error ? (
            <p className="text-red-500">Error: {error}</p>
          ) : (
            <>
              <div className="overflow-hidden rounded-lg shadow-md">
                <table className="w-full bg-gray-800 rounded-lg shadow-lg">
                  <thead>
                    <tr className="bg-yellow text-dark text-left">
                      <th className="py-3 px-6">Username</th>
                      <th className="py-3 px-6">Email</th>
                      <th className="py-3 px-6">Coin</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.map((user) => (
                      <tr
                        key={user.id}
                        className="border-b border-gray-900 hover:bg-gray-700 transition cursor-pointer"
                        onClick={() => navigate(`/user/${user.userId}`)}
                      >
                        <td className="py-4 px-6 text-gray-300">{user.username}</td>
                        <td className="py-4 px-6 text-gray-300">{user.email}</td>
                        <td className="py-4 px-6 text-yellow">{user.coin}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="flex justify-center mt-6 space-x-2 items-center">
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                  className="px-3 py-2 border border-gray-700 bg-dark text-white rounded-md"
                >
                  &laquo;
                </button>

                {Array.from({ length: endPage - startPage + 1 }, (_, i) => {
                  const page = startPage + i;
                  return (
                    <button
                      key={page}
                      className={`px-4 py-2 border border-gray-700 bg-dark text-white rounded-md hover:bg-yellow hover:text-dark transition duration-300 ${
                        currentPage === page
                          ? "bg-yellow text-dark"
                          : "bg-dark hover:bg-yellow hover:text-dark"
                      }`}
                      onClick={() => setCurrentPage(page)}
                    >
                      {page}
                    </button>
                  );
                })}

                <button
                  disabled={currentPage === totalPages}
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  className="px-3 py-2 border border-gray-700 bg-dark text-white rounded-md hover:bg-blue-100"
                >
                  &raquo;
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserList;
